import {
  parseBodyMapFromData,
  parseContentMapFromData,
  parseMaterialMapFromData,
} from "../../utilization/CatchtivityUtilization";
import ActivityBodyContent from "./body-contents/ActivityBodyContent";
import TrueFalseActivityMaterialContent from "./material-contents/TrueFalseActivityMaterialContent";
import { ITrueFalseActivityProps } from "../../properties/ActivityProperties";
import ActivitySolveLayout from "./ActivitySolveLayout";

const TrueFalseActivityContent = ({
  answerMap,
  data,
  canAnswerQuestion,
  changeAnswer,
  isPreview,
  showCorrectAnswer,
  isFullScreen,
  passage,
}: ITrueFalseActivityProps) => {
  const contentMap = parseContentMapFromData(data);
  const trueFalseBodyMap = parseBodyMapFromData(data, "TRUE_FALSE");
  const trueFalseMaterialMap = parseMaterialMapFromData(data, "TRUE_FALSE");

  const handleTrueFalseAnswerOnChange = (
    answerMap: any,
    key: any,
    value: string
  ) => {
    if (isPreview) return;
    if (key === "TRUE") {
      const foundFalseIndex = answerMap.falseList.findIndex(
        (item: string) => item === value
      );
      if (foundFalseIndex !== -1) {
        answerMap.falseList.splice(foundFalseIndex, 1);
      }
      const foundTrueIndex = answerMap.trueList.findIndex(
        (item: string) => item === value
      );
      if (foundTrueIndex === -1) {
        answerMap.trueList.push(value);
      }
    } else if (key === "FALSE") {
      const foundTrueIndex = answerMap.trueList.findIndex(
        (item: string) => item === value
      );
      if (foundTrueIndex !== -1) {
        answerMap.trueList.splice(foundTrueIndex, 1);
      }
      const foundFalseIndex = answerMap.falseList.findIndex(
        (item: string) => item === value
      );
      if (foundFalseIndex === -1) {
        answerMap.falseList.push(value);
      }
    }
    changeAnswer(answerMap);
  };

  return (
    <ActivitySolveLayout
      variant="wide"
      // Safe to pin: toggling True/False never changes the pane's height. Here the
      // statement list is usually the TALL side, so it is the question that pins.
      paneFit
      isFullScreen={isFullScreen}
      passage={passage}
      body={
        <ActivityBodyContent
          bodyMap={trueFalseBodyMap}
          templateType={"TRUE_FALSE"}
        />
      }
      interaction={
        <TrueFalseActivityMaterialContent
          uniqueValue={JSON.stringify(data.contentMap)}
          answerMap={answerMap}
          materialMap={trueFalseMaterialMap}
          contentMap={contentMap}
          checkCanAnswerQuestion={canAnswerQuestion}
          onChange={handleTrueFalseAnswerOnChange}
          isPreview={isPreview}
          showCorrectAnswer={showCorrectAnswer}
        />
      }
    />
  );
};

export default TrueFalseActivityContent;
